// Google Analytics utility functions
// Set REACT_APP_GA_MEASUREMENT_ID in your .env file to enable tracking

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Check if gtag is available and GA is configured
export const isGAEnabled = () => {
  return typeof window !== 'undefined' && 
         typeof window.gtag === 'function' && 
         GA_MEASUREMENT_ID && 
         GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX';
};

// Track page views
export const trackPageView = (path) => {
  if (isGAEnabled()) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (isGAEnabled()) {
    window.gtag('event', eventName, eventParams);
  }
};

// Track button clicks
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location,
  });
};

// Track form submissions
export const trackFormSubmission = (formName, success = true) => {
  trackEvent('form_submission', {
    form_name: formName,
    success: success,
  });
};

// Track external link clicks
export const trackExternalLink = (url, linkText = '') => {
  trackEvent('external_link_click', {
    link_url: url,
    link_text: linkText,
  });
};

// Track app store badge clicks
export const trackAppStoreClick = (store, badgeLocation = '') => {
  trackEvent('app_store_click', {
    store: store, // 'app_store' or 'google_play'
    location: badgeLocation, // e.g., 'footer', 'home_page'
  });
};
